import type { ReactElement, ReactNode } from 'react';
import './PassFailureNotice.css';

export interface PassFailureNoticeProps {
  /** What did not happen, in the person's terms. */
  title: string;
  /** The plain-English reason from the API — never a stack or a model id. */
  reason: string;
  /** Which pass failed (ui.seen `pass_failure`, props.state): story | qa | questions | finalize. */
  logState?: string;
  /** The telling the failed pass belonged to, when the surface knows it. */
  logConversationId?: string;
  /** What still holds, and what they can do next. */
  children?: ReactNode;
}

/**
 * One half of a finalize came back and the other did not (§6.3 runs the story
 * and questions passes independently). The surface whose pass failed says so
 * here — an empty state would read as "your telling held nothing", which is a
 * different, and untrue, thing.
 */
export function PassFailureNotice({ title, reason, logState = 'unspecified', logConversationId, children }: PassFailureNoticeProps): ReactElement {
  return (
    <section className="ember-state-card pass-failure" role="status" data-log-seen="pass_failure" data-log-state={logState} data-log-conversation-id={logConversationId}>
      <span className="ember-state-icon" aria-hidden>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7.5v5.5" />
          <path d="M12 16.4v.2" />
        </svg>
      </span>
      <h2 className="pass-failure-title">{title}</h2>
      <p className="pass-failure-reason">{reason}</p>
      {children && <div className="pass-failure-note">{children}</div>}
    </section>
  );
}
